const publicRoutes = ['/legacy-deprecation'];

export const isPublicRoute = (pathname: string): boolean =>
  publicRoutes.some((publicRoute) => {
    const regex = new RegExp(`${publicRoute}`);

    return regex.test(pathname);
  });
